import { render, staticRenderFns } from "./ClientDataSection.vue?vue&type=template&id=7a333174&scoped=true&"
import script from "./ClientDataSection.vue?vue&type=script&lang=ts&"
export * from "./ClientDataSection.vue?vue&type=script&lang=ts&"
import style0 from "./ClientDataSection.vue?vue&type=style&index=0&id=7a333174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a333174",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VIcon,VRow})
